import { ScaleElement } from '@scale/base-element';

class ScaleBackToTop extends ScaleElement {
  #lastScrollY = 0;
  #scrollDirection = 'up';
  #circumference = 2 * Math.PI * 16; // r=16 from SVG

  setup() {
    this.on('click', this.#scrollToTop);
    window.addEventListener('scroll', this.#onScroll, { passive: true, signal: this.signal });
    this.#onScroll();
  }

  #onScroll = () => {
    this.debounce('scroll', () => this.#update(), 80);
  };

  #update() {
    const scrollY = window.scrollY;
    const docHeight = document.documentElement.scrollHeight - window.innerHeight;
    if (docHeight <= 0) return;

    const percent = (scrollY / docHeight) * 100;
    const threshold = this.getNumber('threshold', 30);

    // Direction (5px dead zone)
    const delta = scrollY - this.#lastScrollY;
    if (Math.abs(delta) > 5) {
      this.#scrollDirection = delta > 0 ? 'down' : 'up';
    }
    this.#lastScrollY = scrollY;

    // Visibility
    const pastThreshold = percent >= threshold;
    const hideDown = this.getBoolean('hide-on-scroll-down') && this.#scrollDirection === 'down' && scrollY > 100;

    this.classList.toggle('is-visible', pastThreshold && !hideDown);
    this.classList.toggle('is-hidden', pastThreshold && hideDown);

    // Progress ring
    const ring = this.ref('ring');
    if (ring) {
      const offset = this.#circumference - (Math.min(percent, 100) / 100) * this.#circumference;
      ring.style.strokeDashoffset = offset;
    }
  }

  #scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
}

if (!customElements.get('scale-back-to-top')) {
  customElements.define('scale-back-to-top', ScaleBackToTop);
}
